
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnItemsGrid extends Serenity.EntityGrid<SalesReturnItemsRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnItems'; }
        protected getDialogType() { return SalesReturnItemsDialog; }
        protected getIdProperty() { return SalesReturnItemsRow.idProperty; }
        protected getInsertPermission() { return SalesReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnItemsRow.localTextPrefix; }
        protected getService() { return SalesReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }


        
    }
}